export default class RequestPaymentDetailsReviewItem {
  constructor(item) {
    this.exportId = item?.exportId ?? null;
    this.file = null;
  }
}
